import { Application } from "stimulus";
import { definitionsFromContext } from "stimulus/webpack-helpers";

const application = Application.start();
window.Stimulus = application;

application.handleError = (error, message, detail) => {
  console.warn(message, detail);
  window.HoneyBadger.report({
    err: error,
    stimulusMessage: message,
    stimulusDetail: detail,
  });
};

const context = require.context("./stimulus_controllers", true, /\.js$/);
application.load(definitionsFromContext(context));
